import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { TranslocoModule } from '@jsverse/transloco';
import { RmaIconComponent } from '@rma/generic/ui/icon';

export interface QrCodeModalData {
  dataUri: string;
}

@Component({
  selector: 'rma-qr-code-download',
  templateUrl: './qr-code-download.component.html',
  styleUrls: ['./qr-code-download.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatDialogContent, MatButtonModule, RmaIconComponent, TranslocoModule],
})
export class QrCodeDownloadComponent {
  private readonly modalData = inject<QrCodeModalData>(MAT_DIALOG_DATA);
  private readonly matDialogRef = inject<MatDialogRef<QrCodeDownloadComponent>>(MatDialogRef);

  public readonly dataUri = this.modalData.dataUri;

  public cancel() {
    this.matDialogRef.close();
  }
}
